import React from 'react';
import Routes from '../../consts/Routes';
import CTButton from './CTButton';

const RegisterButton = () => {
  return <CTButton pushParams={Routes.REGISTER}>Register</CTButton>;
};

export default RegisterButton;
